var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97591 10.667H12.5585C12.9782 10.667 13.3873 10.799 13.7279 11.0444C14.0684 11.2898 14.3231 11.6361 14.4558 12.0343L14.6665 12.667L7.02117 15.0197C6.3657 15.2212 5.6578 15.1624 5.0445 14.8557L0.666504 12.667V8.00033H1.33317C2.06984 8.00033 3.93717 8.29233 4.6665 9.33366H6.6665C7.37375 9.33366 8.05203 9.61461 8.55212 10.1147C9.05222 10.6148 9.33317 11.2931 9.33317 12.0003H5.33317M9.99984 3.33366V4.66699M13.3332 4.00033C13.3332 5.84128 11.8408 7.33366 9.99984 7.33366C8.15889 7.33366 6.6665 5.84128 6.6665 4.00033C6.6665 2.15938 8.15889 0.666992 9.99984 0.666992C11.8408 0.666992 13.3332 2.15938 13.3332 4.00033Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestor);
export default __webpack_public_path__ + "static/media/investor.db875cd8.svg";
export { ForwardRef as ReactComponent };